import { useContext } from 'react'
import { AppContext } from '../context/AppContext'

const useAppContext = () => useContext(AppContext)

export default useAppContext

